<template>
  <div class="diagtitle-modal js-diagtitle-modal overlay-diag-title-change-modal" @click="cancel()">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="diagtitle-modal__bg js-diagtitle-modal-close"></div>
    <div class="diagtitle-modal__content" @click="stopEvent()">
      <div class="diagtitle-modal__header">
        <a class="diagtitle-modal__close js-diagtitle-modal-close" @click="cancel()"></a>
      </div>
      <div class="l-headding is-blueline">診断タイトル変更</div>    
      <div class="diagtitle-modal__search">
        <div class="l-inputBlock">
          <div class="l-inputAccount w-short">
            <TextBox v-model="$v.form.$model.diagTitle" @input="$v.form.$touch()" :disabled="isProcessing" />
            <ValidationErrorMessage v-show="$v.form.diagTitle.$error && !$v.form.diagTitle.required" validation="required" />
          </div>
          <div>
            <div class="btn-basic is-inlne is-primary" @click="register()" :disabled="isProcessing"><a>登録</a></div>
            <div class="btn-basic is-inlne is-primary" @click="cancel()" :disabled="isProcessing"><a>キャンセル</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import { required } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';

export default {
  components: {
    Loading,
    TextBox,
    ValidationErrorMessage,
  },
  props: {
    diagResultId: {

    }
  },
  data() {
    return {
      isProcessing: false,
      form: {
        diagTitle: ''
      }
    }
  },
  validations: {
    form: {
      diagTitle: { required }
    }
  },
  computed: {
    diagTitle() {
      return this.$store.getters['diag/getTitle'];
    },
  },
  watch: {
    diagTitle() {
      this.form.diagTitle = this.$store.getters['diag/getTitle'];
    }
  },
  created: function () {
    this.getDiagResultTitle(this.diagResultId);
  },
  methods: {
    async getDiagResultTitle(diagResultId) {
      if (diagResultId) {
        let res = await this.$axios.post('/ld/api/diag/getDiagResultTitle', {
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.form.diagTitle = res.data.diagTitle;
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/diag/updateDiagResultTitle', {
          diagResultId: this.diagResultId,
          title: this.form.diagTitle,
        });
        if (res.status === 200) {
          this.$toast.info('診断タイトルを変更しました');
          this.$emit("set-new-diag-title", { title: this.form.diagTitle });
          this.$router.go({path: this.$router.currentRoute.path, force: true});
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    cancel() {
      this.$emit("cancel-diag-title-change");
    },
    stopEvent() {
      event.stopPropagation()
    }
  }
}

</script>

<style>
.overlay-diag-title-change-modal {
  display: flex;
  position:fixed;
  align-items: center;
  justify-content: center;
}
</style>
